<template>
  <div class="Sidebar--Discount Discount">
    <form class="Discount--Form" v-if="show_seller_code_form">
      <el-form ref="form"
        @submit.prevent="ApplySellerCode(sellerCode)"
      >
        <el-form-item
          :label="AppConfig.translations.seller_code_form.type_code"
          class="Discount--Input"
        >
          <el-input placeholder v-model="sellerCode" class="input-with-select"
            v-on:keyup.enter="ApplySellerCode(sellerCode)"
          >
            <el-button
              slot="append"
              type="info"
              @click="ApplySellerCode(sellerCode)"
              :loading="CheckoutStatus.SellerCode.add === 'LOADING'"
            >Aplicar</el-button>
          </el-input>
        </el-form-item>
      </el-form>
    </form>
    <div
      class="Discount__Content"
      v-if="sellerCodeApplied"
    >
      <h6>
        <b>Código aplicado:</b>
      </h6>
      <div v-loading="CheckoutStatus.SellerCode.delete === 'LOADING'" class="Discount__List">
        <el-tag
          closable
          size="small"
          :disable-transitions="false"
          @close="removeSellerCode(sellerCodeApplied)"
        >{{sellerCodeApplied}}</el-tag>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'
import { mapFilters } from '@/helpers/filters'

export default {
  name: 'SellerCodeForm',
  components: {},
  data () {
    return {
      sellerCode: '',
      sellerCodeApplied: '',
      loading: false
    }
  },
  props: ['products'],
  created: function () {
    this.GetSellerCodeApplied()
  },
  computed: {
    ...mapGetters(['AppConfig', 'Checkout', 'CheckoutStatus', 'CustomAttributes']),
    show_seller_code_form () {
      if (
        sessionStorage.getItem('show_seller_code_form')
      ) {
        // sessionStorage.removeItem('show_seller_code_form')
        return true
      }
      if (
        this.AppConfig.components.general &&
        this.AppConfig.components.general.seller_code_form
      ) {
        return !!this.AppConfig.components.general.seller_code_form.show_seller_code_form
      }
      return true
    }

  },
  methods: {
    ...mapActions([
      'UpdateCheckoutState',
      'ApplyDiscountCode',
      'ApplyGiftCard',
      'RemoveGiftCard',
      'RemoveDiscountCode',
      'DeleteDiscount',
      'DeleteAddition',
      'SetCustomAttribute',
      'SendCustomAttributes',
      'DeleteCustomAttribute'
    ]),
    ...mapFilters(['formatMoney']),
    async ApplySellerCode (sellerCode) {
      if (this.hasCode(sellerCode)) {
        await this.SetCustomAttribute(['Sagefy_Seller', sellerCode])
        if (this.CustomAttributes) {
          await this.SendCustomAttributes()
          this.sellerCodeApplied = sellerCode
        }
      }
    },
    async removeSellerCode (sellerCode) {
      if (this.hasCode(sellerCode)) {
        await this.DeleteCustomAttribute('Sagefy_Seller')
        this.sellerCodeApplied = ''
      }
    },
    hasCode (code) {
      if (!code) return false
      return code.length > 1
    },
    GetSellerCodeApplied () {
      let noteAttributes = Object.fromEntries(this.Checkout.note_attributes.map(attr => [attr.name, attr.value]))
      let sellerCodeAttr = noteAttributes['Sagefy_Seller']
      if (sellerCodeAttr) {
        this.sellerCodeApplied = sellerCodeAttr
      }
      return sellerCodeAttr ? sellerCodeAttr['Sagefy_Seller'] : null
    }
  }
}
</script>
